import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { ApiStatusResponse } from '@ps/utils';
import {
  OperatorActivityLog,
  SurveyActivityLog,
  SurveyActivityLogEntry,
} from '@ps/survey-utils';

import { SurveyActivityLogPayloadMapper } from './mappers/survey-activity-log-payload.mapper';
import { SurveyActivityLogEntryMapper } from './mappers/survey-activity-log-entry.mapper';
import { SurveyActivityLogListResponseDto } from './survey-activity-log-list.dto';

@Injectable({ providedIn: 'root' })
export class SurveyActivityLogApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new SurveyActivityLogPayloadMapper();
  private readonly _entryMapper = new SurveyActivityLogEntryMapper();

  public post(log: SurveyActivityLog): Observable<void> {
    return this._http
      .post<ApiStatusResponse>(
        `${this._baseUrl}/activities/v2/surveys/${log.surveyId}`,
        this._mapper.toPayload(log),
      )
      .pipe(map(() => undefined));
  }

  public getBySurveyId(surveyId: number): Observable<SurveyActivityLogEntry[]> {
    return this._http
      .get<SurveyActivityLogListResponseDto>(
        `${this._baseUrl}/activities/v2/surveys/${surveyId}`,
      )
      .pipe(map(({ activities }) => this._entryMapper.fromDtoList(activities)));
  }

  public postOperator(log: OperatorActivityLog): Observable<void> {
    return this._http
      .post<ApiStatusResponse>(
        `${this._baseUrl}/activities/v2/operator`,
        this._mapper.toOperatorPayload(log),
      )
      .pipe(map(() => undefined));
  }
}
